import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var heading_level_4_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M20 13V7h-3l-4 6v2h5v2h2v-2h1v-2h-1zm-2 0h-2.8L18 9v4zm-9-2H5V7H3v10h2v-4h4v4h2V7H9v4z" }) });
export {
  heading_level_4_default as default
};
//# sourceMappingURL=heading-level-4.js.map
